import { Route } from 'common/types/tech';
import { useLayoutEffect, useState } from 'react';
import { Location, matchRoutes, useLocation } from 'react-router-dom';
import { useAppRoutes } from 'common/constants/routes/app-type-context';

export const findCurrentRoute = (location: Location, routes: Route[]) => {
  return routes.find(r => matchRoutes([{ path: r.path }], location));
};

export const chechIsRouteUnprotected = (location: Location, routes: Route[]) => {
  return !findCurrentRoute(location, routes)?.protected;
};

export function useCurrrentRoute() {
  const location = useLocation();

  // Compute routes dynamically on every render
  const routes = useAppRoutes();

  const [isProtectedRoute, setIsProtectedRoute] = useState<boolean>(!chechIsRouteUnprotected(location, routes));
  const [route, setRoute] = useState<Route>(findCurrentRoute(location, routes));

  useLayoutEffect(() => {
    setIsProtectedRoute(!chechIsRouteUnprotected(location, routes));
    setRoute(findCurrentRoute(location, routes));
  }, [location, routes]);

  return { isProtectedRoute, route };
}
